export enum ToolTypes {
  sap = 'SAP',
  excel = 'Excel',
  word = 'Word',
  outlook = 'Outlook',
}
